<template>
  <div class="title-container">
    <div class="title">
      <span class="title-text">{{ pageTitle }}</span>
    </div>
    <div v-if="pageComment !== ''" class="page-remark">
      <span class="remark-text">{{ pageComment }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "pageTitle",
  props: ["pageTitle", "pageComment"],
};
</script>
<style lang="scss" scoped>
.title-container {
  padding: 12px 24px 16px 24px;
  background-color: #fff;
}
.title {
  height: 40px;
  padding: 8px 0px 0px 0px;
}
.title-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.page-remark {
  padding: 12px, 0px, 0px, 0px;
}
.remark-text {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
</style>
